/**
 * https://kapi.corp.kuaishou.com/project/10525/interface/api/cat_114047
 */
import {
  GetAuditConfigsResBody,
  GetAuditEntranceResBody,
  GetAuditTagsResBody,
  GetRecordsReqQuery,
  GetRecordsResBody,
  GetTasksReqQuery,
  GetTasksResBody,
  GetVideoReviewProgressResBody,
  GetVideoReviewOptions,
  SubmitTaskReqBody
} from '@/schemas/video-review';
import { ApiConfigs, ResponseV2 } from '@schemas/service';
import { request } from './request';

const api: ApiConfigs = {
  getTasks: {
    url: '/health/api/v1/doctor/audit/tasks',
    method: 'GET'
  },
  getRecords: {
    url: '/health/api/v1/doctor/audit/records',
    method: 'GET'
  },
  submitTask: {
    url: '/health/api/v1/doctor/audit/task/submit',
    method: 'POST'
  },
  getUndeterminedTasks: {
    url: '/health/api/v1/doctor/audit/undetermined-tasks',
    method: 'GET'
  },
  getAuditEntrance: {
    url: '/health/api/v1/doctor/audit/entrance',
    method: 'GET'
  },
  getVideoReviewTags: {
    url: '/health/api/v1/doctor/audit/tags',
    method: 'GET'
  },
  addVideoReviewTags: {
    url: '/health/api/v1/doctor/audit/tags',
    method: 'POST'
  },
  getVideoReviewConfig: {
    url: '/health/api/v1/doctor/audit/configs',
    method: 'GET'
  },
  getVideoReviewProgress: {
    url: '/health/api/v1/doctor/audit/progress',
    method: 'GET'
  },
  getVideoReviewOptions: {
    url: '/health/api/v1/doctor/audit/options',
    method: 'GET'
  }
};

const VideoReview = {
  async getTasks(params: GetTasksReqQuery) {
    try {
      const response: ResponseV2<GetTasksResBody> = await request(
        api.getTasks,
        { ...params }
      );
      const { data } = response;
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getRecords(params: GetRecordsReqQuery) {
    try {
      const response: ResponseV2<GetRecordsResBody> = await request(
        api.getRecords,
        { ...params }
      );
      const { data } = response;
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async submitTask(body: SubmitTaskReqBody) {
    try {
      const response: ResponseV2 = await request(
        api.submitTask,
        undefined,
        body
      );
      const { data } = response;

      return data;
      // return new Promise((resolve, reject) =>
      //   setTimeout(() => {
      //     resolve(true);
      //     // reject(new Error('false'));
      //   }, 100)
      // );
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getUndeterminedTasks(params: GetTasksReqQuery) {
    try {
      const response: ResponseV2<GetTasksResBody> = await request(
        api.getUndeterminedTasks,
        { ...params }
      );
      const { data } = response;
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getAuditEntrance() {
    try {
      const response: ResponseV2<GetAuditEntranceResBody> = await request(
        api.getAuditEntrance
      );
      const { data } = response;
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getVideoReviewTags() {
    try {
      const response: ResponseV2<GetAuditTagsResBody> = await request(
        api.getVideoReviewTags
      );
      const { data } = response;

      const selectedTags: {
        id: number;
        name: string;
        parent: string;
        tagParent: string;
        defaultSelected: boolean;
      }[] = [];

      for (const auditTag of data) {
        for (const curTag of auditTag.tags) {
          for (const subTag of curTag.subTags) {
            if (subTag.selected) {
              const selectedSubTag = {
                ...subTag,
                parent: auditTag.name,
                tagParent: curTag.name
              };
              selectedTags.push(selectedSubTag);
            }
          }
        }
      }
      const parent =
        selectedTags.filter((tag) => !tag.defaultSelected).length > 1
          ? selectedTags.filter((tag) => !tag.defaultSelected)[1].parent
          : selectedTags.filter((tag) => !tag.defaultSelected).length !== 0
          ? selectedTags.filter((tag) => !tag.defaultSelected)[0].parent
          : '';
      const filterSelectedTags = selectedTags.filter(
        (tag) => !parent || tag.parent === parent
      );
      return {
        auditTags: data,
        selectedTags: filterSelectedTags
      };
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async addVideoReviewTags(tags: number[], provinceIds?: string[]) {
    try {
      const response: ResponseV2 = await request(
        api.addVideoReviewTags,
        undefined,
        {
          tags: Array.from(new Set(tags)),
          provinceIds
        }
      );
      const { data } = response;
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getVideoReviewConfig() {
    try {
      const response: ResponseV2<GetAuditConfigsResBody> = await request(
        api.getVideoReviewConfig
      );
      const { data } = response;
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getVideoReviewProgress() {
    try {
      const response: ResponseV2<GetVideoReviewProgressResBody> = await request(
        api.getVideoReviewProgress
      );
      const { data } = response;
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getVideoReviewOptions() {
    try {
      const response: ResponseV2<GetVideoReviewOptions> = await request(
        api.getVideoReviewOptions
      );
      const { data } = response;
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default VideoReview;
